import { i18n } from '@lingui/core';

type Config = {
  language: GLOBALS.Language;
};

const DEFAULT_LANG: Config['language'] = 'en';

export const setupI18n = ({ language = DEFAULT_LANG }: Config) => {
  const messages = {};

  i18n.load(language, messages);
  i18n.activate(language);
};
